
<template>
    
        <mars-view :style="{
        fontSize
    }" :class="'ms-icon-' + name" class="msui-iconfont icon"></mars-view>
    
</template>

<script>
export default {
  props: {
    /**
     * icon name
     */
    name: {
      type: String
    },

    /**
     * icon font-size
     */
    fontSize: {
      type: String
    }
  },
  options: {
    // 添加全局类
    addGlobalClass: true
  }
};
</script>

<style scoped>
@import "../../msui-iconfont/iconfont.css";
.icon {
  display: inline-block;
}

</style>
